import { DateTime } from "luxon";
import { sessionStorageService } from "../services/SessionStorageService";
import { trackErrorEvent } from "./analytics";

// Within this long of a recovery reload, another failed chunk is a real outage, not a stale tab.
const RELOAD_GUARD_MS = 5 * 60 * 1000;

/**
 * Vite's documented recovery for a lazy chunk that failed to load, usually because a deploy removed
 * the files a tab's old index.html names: reload once to pick up the new build. The guard keeps a
 * chunk that still fails from reloading forever; then the error reaches the ErrorBoundary.
 */
export const installPreloadErrorReload = (): void => {
	window.addEventListener("vite:preloadError", (event) => {
		const now = DateTime.now().toMillis();
		const lastReloadAt = sessionStorageService.getLastChunkReloadAt();
		if (lastReloadAt !== null && now - lastReloadAt < RELOAD_GUARD_MS) return;

		sessionStorageService.setLastChunkReloadAt(now);
		// Storage blocked: the reloaded page couldn't tell it already tried, so it could loop.
		if (sessionStorageService.getLastChunkReloadAt() !== now) return;

		trackErrorEvent("chunk_preload_error_reload", event.payload);
		event.preventDefault();
		window.location.reload();
	});
};
